
import { MapLocation } from '@/types/location';

// The World of Creativity Gym Locations
export const worldOfCreativityGyms: MapLocation[] = [
  {
    id: 32001,
    name: "The World of Creativity - Riyadh (Al Qadisiyah)",
    type: "Gym",
    devices: 3,
    coordinates: [24.81545195648957, 46.83482850489983],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
